/** System actions for FE version checks, refresh prompts, and fatal error state. */
export const systemAction = {
    checkFEVersion: (showErrorOnVersionMismatchAndNoNewFeVersion?: boolean) => ({
        type: 'system/CHECK_FE_VERSION',
        payload: {showErrorOnVersionMismatchAndNoNewFeVersion},
    }) as const,
    changeRefreshModalVisibility: (visible: boolean) => ({
        type: 'system/CHANGE_REFRESH_MODAL_VISIBILITY',
        payload: {visible},
    }) as const,
    changeServerError: (error: boolean) => ({
        type: 'system/CHANGE_SERVER_ERROR',
        payload: {error},
    }) as const,
};

/** Action used when the app polls for a new FE version. */
export type CheckFEVersionAction = ReturnType<typeof systemAction.checkFEVersion>;
/** Action used to show or hide the refresh modal. */
export type ChangeRefreshModalVisibilityAction = ReturnType<typeof systemAction.changeRefreshModalVisibility>;
/** Action used to store whether the shell is in a server-error state. */
export type ChangeServerErrorAction = ReturnType<typeof systemAction.changeServerError>;

/** Action union handled by the system reducer and FE version polling saga. */
export type SystemAction =
    | CheckFEVersionAction
    | ChangeRefreshModalVisibilityAction
    | ChangeServerErrorAction
    ;
